import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

export const ChartContainer = styled.div`
  margin-bottom: 40px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  padding: 20px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const ChartTitle = styled.h3`
  text-align: center;
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
`;

export const ChartSubtitle = styled.p`
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 0;
  margin-bottom: 20px;
`;

export const ChartSource = styled.p`
  text-align: right;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 0;
  font-style: italic;
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: ${breakpoints.md}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
